<!-- APPOINTMENT TYPE ON MOBILE. -->
<section id="mobile-appointments">
	<!-- HEADER. -->
	<section class="mobileSingleHeader">
		<img class="mnuIcon" src="/assets/images/icons/calendar.svg" />
		<span class="pageTitle">{{ 'SCHEDULE.NEWSESSION' | translate }}</span>
		<fa-icon
			icon="times"
			class="times"
			(click)="goToPage('calendar')"
		></fa-icon>
	</section>
	<!-- /mobileSingleHeader. -->

	<!-- SESSION TYPES. -->
	<section class="newSessionType">
		<!-- Title. -->
		<h1>{{ 'SCHEDULE.SESSIONTYPE' | translate }}</h1>

		<!-- Availatiblity. -->
		<div
			class="sessionType stAvailabilities"
			(click)="goToPage('availabilities')"
		>
			<div class="stContainer">
				<div class="stIcon">
					<img class="mnuIcon" src="/assets/images/icons/availabilities2.svg" />
				</div>
				<div class="stTitle">
					{{ 'SCHEDULE.SESSIONTYPES.UNAVAILABILITIES' | translate }}
				</div>
				<div class="stIcon stIconRight">
					<fa-icon icon="angle-right"></fa-icon>
				</div>
			</div>
		</div>

		<!-- Online session. -->
		<div class="sessionType stOnline" (click)="showScreen('online')">
			<div class="stContainer">
				<div class="stIcon">
					<img class="mnuIcon" src="/assets/images/icons/inviteonline.svg" />
				</div>
				<div class="stTitle">
					{{ 'SCHEDULE.SESSIONTYPES.ONLINE' | translate }}
				</div>
				<div class="stIcon stIconRight">
					<fa-icon icon="angle-right"></fa-icon>
				</div>
			</div>
		</div>

		<!-- Personal commitment. -->
		<div class="sessionType stPersonal" (click)="showScreen('personal')">
			<!-- <div class="sessionType stPersonal"> -->
			<div class="stContainer">
				<div class="stIcon">
					<img
						class="mnuIcon"
						src="/assets/images/icons/personalappointment.svg"
					/>
				</div>
				<div class="stTitle">
					{{ 'SCHEDULE.SESSIONTYPES.PERSONAL' | translate }}
				</div>
				<div class="stIcon stIconRight">
					<fa-icon icon="angle-right"></fa-icon>
				</div>
			</div>
		</div>
	</section>
	<!-- /newSessionType. -->
</section>
<!-- /mobile-appointments. -->
